import React from "react";
import { Layout, Typography } from "antd";

const { Footer: AntFooter } = Layout;
const { Text } = Typography;

const Footer = () => {
    return (
        <AntFooter className="app-footer">
            <Text style={{ color: "var(--app-footer-fg)" }}>© 2025 narucitaxi.com</Text>
        </AntFooter>
    );
};

export default Footer;
